import React, { Component } from 'react';
import SavedSearchCard from '../SavedSearch/SavedSearchCard';
import IntlMessages from '../../../util/IntlMessages';
class RecentSearch extends Component {
  state = {
    recentData: [],
  };
  componentDidUpdate(prevProps) {
    if (prevProps.recent !== this.props.recent) {
      this.setState({ recentData: this.props.recent });
    }
  }
  render() {
    let { recentData } = this.state;
    return (
      <div className="rightBlockItem">
        <div className="rightBlockHead">
          <IntlMessages id="app.recentsearchtitle" />
        </div>
        <div className="sacedSearchBox">
          {recentData && recentData.length !== 0 ? (
            recentData.map((recent, ind) => {
              return <SavedSearchCard recentSearch saveId={recent.id} saveDetail={recent} key={ind} />;
            })
          ) : (
            <IntlMessages id="app.noRecentSearch" />
          )}
          {/* <SavedSearchCard recentSearch />
                    <SavedSearchCard recentSearch />
                    <SavedSearchCard recentSearch /> */}
        </div>
      </div>
    );
  }
}
export default RecentSearch;
